// extracted by mini-css-extract-plugin
module.exports = {"geometryBgDark":"background_geometryBgDark__XJqNI","geometryBgLight":"background_geometryBgLight__5T_RI"};